// Workflow Composable functions
import check from "@/../../library/helper/propertyCheck";

export function loadWorkflow(table, item) {
    // Table name to workflow properties map
    const map = Object.freeze({
        "crm_release_notes": {
            component: "ReleaseNotes.vue",
            title: "Release Notes"
        }
    })

    const c = () => import(`@/components/workflows/${map[table]["component"]}`)
    let def = {
        title: map[table]["title"],
        component: c,
        popup: true
    }
    if (!check.isUndefined(item) && !check.isEmptyString(item)) {
        def["item"] = item["_id"]
    }
    return def
}